import {
  GET_PLUGINS,
  GET_PLUGIN,
  PLUGINS_LOADING,
  PLUGINS_SUCCESS,
  PLUGINS_ERROR,
  RESET_PLUGINS_MSG,
} from '../Types/PluginsTypes';

const initialState = {
  plugins: [],
  currentPlugin: null,
  loading: false,
  success: null,
  error: null,
};

export default function PluginsReducer(state = initialState, action) {
  switch (action.type) {
    case PLUGINS_LOADING:
      return { ...state, loading: true, success: null, error: null };
    case GET_PLUGINS:
      return { ...state, loading: false, plugins: action.payload ?? [] };
    case GET_PLUGIN:
      return { ...state, loading: false, currentPlugin: action.payload };
    case PLUGINS_SUCCESS:
      return { ...state, loading: false, success: action.payload };
    case PLUGINS_ERROR:
      return { ...state, loading: false, error: action.payload };
    case RESET_PLUGINS_MSG:
      return { ...state, success: null, error: null };
    default:
      return state;
  }
}
